import * as net from 'util/Net';

import {Permissions} from './PermissionConstants';

export function bulkFetchPermissions(ids: Array<string>): Promise<{[id: string]: Permissions}> {
  return net.postJSONPromise({
    url: '/1/api/permissions:bulk-get',
    data: {ids},
  });
}
